const DASHBOARD_ALIAS_PARAM = "d";
const LEGACY_DASHBOARD_PARAM = "dashboard_name";
const DASHBOARD_ALIAS_PREFIX = "d-";

const toDashboardKey = (dashboardName) => String(dashboardName || "").trim();

export const getDashboardAlias = (dashboardName) => {
  const key = toDashboardKey(dashboardName);

  let hash = 2166136261;
  for (let i = 0; i < key.length; i += 1) {
    hash ^= key.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }

  return `${DASHBOARD_ALIAS_PREFIX}${(hash >>> 0).toString(36)}`;
};

export const buildDashboardRoute = (dashboardName) => {
  const params = new URLSearchParams({
    [DASHBOARD_ALIAS_PARAM]: getDashboardAlias(dashboardName),
  });

  return `/dashboard?${params.toString()}`;
};

export const buildLegacyDashboardRoute = (dashboardName) => {
  const params = new URLSearchParams({
    [LEGACY_DASHBOARD_PARAM]: toDashboardKey(dashboardName),
  });

  return `/dashboard?${params.toString()}`;
};

export const decorateDashboardRouteMeta = (dashboardConfig) => {
  const dashboardName = toDashboardKey(dashboardConfig?.dashboardName);

  return {
    ...dashboardConfig,
    dashboardAlias: getDashboardAlias(dashboardName),
    legacyPath: buildLegacyDashboardRoute(dashboardName),
    path: buildDashboardRoute(dashboardName),
  };
};

export const resolveDashboardNameFromSearch = (subTabs = [], search = "") => {
  const params = new URLSearchParams(search);
  const alias = params.get(DASHBOARD_ALIAS_PARAM);

  if (alias) {
    return (
      subTabs.find(
        (subTab) =>
          subTab?.dashboardAlias === alias || subTab?.dashboardName === alias,
      )?.dashboardName || null
    );
  }

  const legacyDashboardName = params.get(LEGACY_DASHBOARD_PARAM);
  if (!legacyDashboardName) {
    return null;
  }

  return (
    subTabs.find(
      (subTab) =>
        subTab?.dashboardName === legacyDashboardName ||
        subTab?.dashboardAlias === legacyDashboardName,
    )?.dashboardName || legacyDashboardName
  );
};
